import { ActionBarProps } from './types'

export const ActionBar = ({
  onConfirm,
  onCancel,
  canConfirm,
  children
}: ActionBarProps) => {
  return (
    <div className='flex justify-between border-t-2 border-gray-200 px-6 py-3'>
      <div className='ml-auto flex'>
        <div className='grid h-10 grid-cols-2 gap-2'>
          <button
            className='ml-auto w-24 px-6 font-semibold uppercase text-gray-700'
            onClick={onCancel}
          >
            Cancel
          </button>
          <button
            className='rounded bg-lighthouseBlue px-6 py-2 font-semibold text-white disabled:opacity-50'
            onClick={onConfirm}
            disabled={!canConfirm}
          >
            <span className='uppercase'>{children}</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default ActionBar
